import GoalLevelUtils from "utils/GoalLevelUtils";

function GoalLevelDisplay({ patientDob, className }) {
  if (!patientDob) return null;

  const goalLevel = GoalLevelUtils.getGoalLevel(patientDob);

  return (
    <div className={className} title={`Target age band: ${goalLevel.description}`}>
      <span className="goal-level-display__label">Goal level</span>
      <span className="goal-level-display__value">{goalLevel.level}</span>
      <span className="goal-level-display__meta">{goalLevel.description}</span>
    </div>
  );
}

export default GoalLevelDisplay;
